import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';
import TimestampAble          from '@widesk-core/models/traits/TimestampAble';
import Blamable               from '@/models/traits/Blamable';
import FondationsServiceModel from '@/models/FondationsServiceModel';
import EntityTypeModel        from '@models/fondations/EntityTypeModel';
import EntityStatusModel      from '@models/fondations/EntityStatusModel';
import EntityCategoryModel    from '@models/fondations/EntityCategoryModel';
import { RenderNameProps }    from '@widesk-ui/mixins/ApiModelRenderName';
import UserModel              from '@models/fondations/UserModel';

@model.urnResource('entity')
@doc.path('/entities/{?id}')
export default class EntityModel extends Blamable(TimestampAble(FondationsServiceModel)) {
	private declare _tsFilters: {
		'id': id;
		'corporateName': string;
		'commercialName': string;
		'identificationNumber': string;
		'intraCommunityNumber': string;
		'clientReference': string;
		'entityCategory': id;
		'activityDomain': id;
		'entityType': id;
		'entityStatus': id;
		'country': CountryCode;
		'isSubjectToVat': boolean;
	};

	private declare _tsSorts: {
		'id': string;
		'corporateName': string;
		'commercialName': string;
		'createdAt': string;
	};

	@doc.string declare corporateName: string;
	@doc.string declare commercialName: string;
	@doc.string declare identificationNumber: string;
	@doc.string declare intraCommunityNumber: string;
	@doc.string declare website: string;
	@doc.string declare legalForm: string;
	@doc.string declare clientReference: string;
	@doc.string declare country: CountryCode;
	@doc.string declare sourceUrn: Urn;
	@doc.boolean declare isSubjectToVat: boolean;
	@doc.modelUrn(UserModel) declare accountManager: UserModel;
	@doc.model(EntityCategoryModel) declare entityCategory: EntityCategoryModel;
	@doc.model(EntityTypeModel) declare entityType: EntityTypeModel;
	@doc.model(EntityStatusModel) declare entityStatus: EntityStatusModel;

	public renderName(props?: RenderNameProps<this> & EntityNameProps) {
		return super.renderName(props);
	}

	public get fondationsLink() {
		return `${window.APP_CONFIG.services.find(s => s.id === 'fondations')?.url}entities/${this.id}`;
	}
}
